<template>
	<div>
		<div>
			<input
				style="width: 100%"
				id="sliderRange"
				class="ms-input-item"
				v-model="internalText"
				v-bind="$attrs"
				ref="input"
				v-on="listeners"
				type="range"
				:max="max"
				:min="min"
				:step="step"
				:class="classInputRange"
			/>
		</div>
		<div class="flex jus-between ms-mgl-5px">
			<div v-for="index in 10" :key="index">{{ index }}</div>
		</div>
	</div>
</template>
<script>
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
export default {
	extends: msBaseComponent,
	name: 'MsInputRange',
	props: {
		/**
		 * V-model bắn ra ngoài binding 2 chiều
		 */
		value: {
			default: null,
		},
		//class chứa icon
		icon: {
			default: null,
			type: String,
		},
		subtext: {
			default: null,
			type: String,
		},
		max: {
			default: 10,
			type: Number,
		},
		min: {
			default: 0,
			type: Number,
		},
		step: {
			default: 1,
			type: Number,
		},
		//Mã màu từ đầu đến vị trị hiện tại
		rangeProcess: {
			type: String,
			default: '#000',
		},
		// Mã màu của phần còn lại
		rangeStill: {
			type: String,
			default: '#e4e6eb',
		},
	},
	data() {
		return {
			internalText: this.value,
			focused: false,
			displayValue: null,
			classInput: '',
		};
	},
	computed: {
		listeners() {
			return {
				blur: (e) => {
					this.onBlur(e);
				},
				focus: (e) => {
					this.onFocus(e);
				},
				change: (e) => {
					this.change(e);
				},
				keydown: (e) => {
					this.$emit('keydown', e);
				},
			};
		},
		classInputRange() {
			return this.classInput;
		},
	},
	created() {},
	methods: {
		clickIcon(e) {
			const me = this;
			me.$emit('change', me.internalText, e);
		},
		//Sự kiện focus vào ô input
		onFocus(e) {
			const me = this;
			me.focused = true;
			me.$emit('focus', e);
		},
		//Sự kiên blur ra ngoài ô input
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
		},
		//Reset lại giá trị về ban đầu
		reset() {
			const me = this;
			me.internalText = null;
			me.displayValue = null;
		},
		change(e) {
			const me = this;
			me.$emit('change', me.internalText, e);
		},
		//Set giá trị cho ô input
		setValue(value) {
			const me = this;
			me.internalText = value;
		},
		setColorRangeProcess(val) {
			const me = this;
			let inputElement = document.getElementById('sliderRange');
			if (inputElement) {
				var value = Math.ceil(((val - this.min) / (this.max - this.min)) * 100);
				inputElement.style.background = `linear-gradient(to right, ${me.rangeProcess} 0%, ${me.rangeProcess} ${value}%, ${me.rangeStill} ${value}%, #fff 100%)`;
			}
		},
		setClassInput(value) {
			const me = this;
			if (value) {
				if (value >= 0.9 * me.max) {
					me.classInput = 'happy';
				} else if (value >= 0.7 * me.max) {
					me.classInput = 'normal';
				} else if (value < 0.7 * me.max && value >= 0) {
					me.classInput = 'sad';
				}
			}
		},
	},
	watch: {
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
				me.$emit('input', newVal);
				me.$nextTick(() => {
					this.validate();
				});
			},
		},
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setValue(newVal);
				me.setColorRangeProcess(newVal);
				me.setClassInput(newVal);
			},
		},
		disabled: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.validate();
				}
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msInput.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msInput.scss';
}
::-webkit-input-placeholder {
	font-style: italic;
}
:-moz-placeholder {
	font-style: italic;
}
::-moz-placeholder {
	font-style: italic;
}
:-ms-input-placeholder {
	font-style: italic;
}
#sliderRange {
	background: linear-gradient(
		to right,
		#0db46a 0%,
		#0db46a 88%,
		#e4e6eb 88%,
		#e4e6eb 100%
	);
	border: solid 1px var(--ms-color-border);
	border-radius: var(--base-border-radius);
	height: 7px;
	width: 356px;
	outline: none;
	transition: background 450ms ease-in;
	-webkit-appearance: none;
}
input[type='range']::-webkit-slider-thumb {
	-webkit-appearance: none;
	border-radius: 50%;
	border: 4px solid #fff;
	width: 16px;
	height: 16px;
	// transition: background .3s ease-in-out;
	position: relative;
	top: 0px;
	// box-shadow: #e5e5e5;
	background: #18bb7a;
	box-shadow: 0 0 6px #ced0d4;
}
.happy::-webkit-slider-thumb {
	background: #18bb7a !important;
}
.normal::-webkit-slider-thumb {
	background: #ffa200 !important;
}
.sad::-webkit-slider-thumb {
	background: #f85959 !important;
}
</style>

